import { useLocation } from 'react-router-dom';

const BACKEND = import.meta.env.VITE_BACKEND_URL?.replace(/\/$/, ''); // strip trailing slash

export function useSocialLogin() {

    const location = useLocation();

    const signupWithGoogle = (destination = '/sign-up/add-teams-competitions') => {

        const url = new URL(`${BACKEND}/auth/google/redirect`);
        url.searchParams.set('destination', destination);
        window.location.href = url.toString();
    };

    const steppedSignUpFlowWithGoogle = (destination = '/sign-up/finish') => {

        // window.location.href below is a hard navigation, so router state
        // (e.g. redirectTo set by whatever page linked into this flow) would
        // otherwise be lost - stash it so it can be picked back up once the
        // OAuth round-trip lands the user back in the app.
        if (location.state?.redirectTo) {
            sessionStorage.setItem('trial_signup_redirect_to', location.state.redirectTo);
        }

        const url = new URL(`${BACKEND}/auth/google/redirectSignUp`);
        url.searchParams.set('destination', destination);
        window.location.href = url.toString();
    };

    const signinWithGoogle = (destination = '/dashboard') => {

        const url = new URL(`${BACKEND}/auth/google/signin`);
        url.searchParams.set('destination', destination);
        window.location.href = url.toString();
        
       
    };

    return { signupWithGoogle, steppedSignUpFlowWithGoogle, signinWithGoogle };
}